import { useCallback, useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { voiceAssistantsApi } from "@/voice-assistants/lib/api";
import type { VoiceAssistantRetellAccount } from "@/voice-assistants/types/database.types";

export function useRetellAccount() {
  const { activeWorkspaceId } = useAuth();
  const [accounts, setAccounts] = useState<VoiceAssistantRetellAccount[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!activeWorkspaceId) {
      setAccounts([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const { accounts } = await voiceAssistantsApi.listRetellAccounts(activeWorkspaceId);
      setAccounts(accounts ?? []);
    } catch {
      setAccounts([]);
    }
    setLoading(false);
  }, [activeWorkspaceId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const defaultAccount = accounts.find((a) => a.is_default && a.is_active) ?? accounts[0] ?? null;
  const hasAccount = accounts.some((a) => a.is_active);

  return { accounts, defaultAccount, hasAccount, loading, refresh };
}
